import { gql } from '@apollo/client'

export default gql(`
    mutation enableUser($id: String $project: String) {
        enableUser(
            input: {
                id: $id
            }
            project: $project
        ){
            id
        }
    }
`)
